import home from './src/home.vue'

import UserView from './src/UserManager/UserView.vue' //用户管理列表页
import UserRoleView from './src/UserManager/UserRoleView.vue' //用户角色列表页

import RoleView from './src/RoleManager/RoleView.vue' //角色管理列表页
import RoleUserView from './src/RoleManager/RoleUserView.vue' //角色用户列表页

import DeptView from './src/DeptManager/DeptView.vue' //组织架构列表页
import LogView from './src/LogManager/LogView.vue' //操作日志列表页
import LoginLogview from './src/LogManager/LoginLogview.vue' //登录日志

let views = {
    home,
    UserView,
    UserRoleView,
    RoleView,
    RoleUserView,
    DeptView,
    LogView,
    LoginLogview
};

export default views;